export const validateNumber = (number: string) => {
  return /^\d*\.?\d*$/.test(number)
}
